import React, {Component} from 'react'
import {Grid, Hidden, withStyles} from "@material-ui/core"
import FontW9 from "../Font/FontW9";

const style = theme => ({
   fixHeight: {
      display: 'flex',
      justifyContent: 'center',
   },
   fixContent: {
      width: 470,
      margin: 'auto 0 auto auto',
      flex: ' none !important',
      textAlign: 'justify',
      textJustify: 'auto',
      [theme.breakpoints.down('md')]: {
         width: '100%',
      },
      [theme.breakpoints.down('sm')]: {
         textAlign: 'center',
      },
   },
   title: {
      // whiteSpace: "nowrap",
      fontSize: "32pt",
      lineHeight: 1.5,
      [theme.breakpoints.down('sm')]: {
         fontSize: "21pt",
      },
   },
   fixImg: {
      // minWidth: 545,
      maxHeight: '46vw',
      width:'75%',
      maxWidth: '100vh',
      marginLeft: 0,
      marginBottom: 'auto',
      marginTop: 'auto',
      // [theme.breakpoints.down('md')]: {
      //    marginLeft: -39,
      // },
      [theme.breakpoints.down('sm')]: {
         maxHeight: '100vw',
         minWidth: 0,
         marginLeft: 0,
      },
   }
})

class ServicesRight extends Component {
   render() {
      const {img, title, content, backgroundImage, borderColor, classes} = this.props
      return (
         <Grid container data-scroll-index="2" id="section-2" className="clearfix services-style-2 display-flex">
            <Hidden mdUp>
               <Grid item xs={12} className={"bg-div-cover " + classes.fixHeight}
                     style={{backgroundImage: `url(${backgroundImage})`}}>
                  <img
                     src={img}
                     alt={title}
                     className={"wow fadeInUp " + classes.fixImg}
                     data-wow-delay=".3s"
                     width={'100%'}
                     height={'100%'}
                  />
               </Grid>
            </Hidden>
            <Grid container item md={6} xs={12} style={{backgroundColor: 'white'}}>
               <Grid item xs={12} className="row icon-container" style={{height: '100%'}}>
                  <div
                     className="box-border clearfix"
                     style={{
                        border: `1px solid ${borderColor}`,
                        height: '100%',
                        display: 'flex',
                     }}
                  >
                     <div className={"wow fadeInDown " + classes.fixContent} data-wow-delay=".2s">
                        <div
                           className="icon-box"
                           style={{
                              color: 'black',
                              marginBottom: 0,
                           }}
                        >
                           <FontW9 className={classes.title}>{title}</FontW9>
                           {/*<div className="divider"></div>*/}
                           <div className="font-han-sans-w5 font-16px mt40">{content}</div>
                        </div>
                     </div>
                  </div>
               </Grid>
            </Grid>
            <Hidden smDown>
               <Grid item xs={6} className={"bg-div-cover " + classes.fixHeight}
                     style={{backgroundImage: `url(${backgroundImage})`}}>
                  <img
                     src={img}
                     alt={title}
                     className={"wow fadeInUp " + classes.fixImg}
                     data-wow-delay=".3s"
                     width={'100%'}
                     height={'100%'}
                  />
               </Grid>
            </Hidden>
         </Grid>
      )
   }
}

export default withStyles(style)(ServicesRight)
